import type { ReactNode } from 'react';

interface SplitViewProps {
  left: ReactNode;
  right: ReactNode;
}

export function SplitView({ left, right }: SplitViewProps) {
  return (
    <div className="flex h-full">
      {/* Left pane - Search and results */}
      <div className="w-1/2 overflow-auto border-r border-outline">
        {left}
      </div>

      {/* Right pane - Card detail */}
      <div className="w-1/2 overflow-auto bg-card">
        {right}
      </div>
    </div>
  );
}
